import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './WhitepaperDownload.css';

export default function WhitepaperDownload() {
  const { uuid } = useParams();
  const API_URL = process.env.REACT_APP_API_URL;
  const pdfViewUrl = `${API_URL}/whitepaper/${uuid}/view`;

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="whitepaper-download-wrapper">
      <div className="whitepaper-pdf-container">
        <embed
          src={pdfViewUrl}
          type="application/pdf"
          width="100%"
          height="100%"
          style={{ border: 'none' }}
          title="Whitepaper Document"
          aria-label="Whitepaper Document"
        />
      </div>
    </div>
  );
} 